module.exports = __webpack_public_path__ + "static/media/social6.6bbec8b9.png";